import React from 'react';
import { ZapIcon } from 'lucide-react';
import { howSteps } from '../../data/samplePrompts';
export function PromptDemo() {
  return <div className="mx-auto mt-12 max-w-3xl" data-id="element-199" data-mp="31p59y3gqrvz7">
      <h3 className="font-display text-xl font-black text-plum sm:text-2xl" data-id="element-200" data-mp="3gmnx51dru14j">
        <ZapIcon className="mr-1.5 inline h-5 w-5 -translate-y-0.5 text-grape" aria-hidden="true" data-id="element-201" data-mp="3gkl92mw6ii2g" />
        How it works
      </h3>

      <div className="mt-4 overflow-hidden rounded-2xl border border-plum/15 bg-white" data-id="element-202" data-mp="2nxqsw26ea4us">
        <ol className="divide-y divide-plum/10" data-id="element-203" data-mp="2izfj1rg3nuck">
          {howSteps.map((s, i) => <li key={s.title} className="flex gap-4 p-4 sm:p-5" data-id="element-204" data-mp="2xo3b3nqqllxr" data-mpi={i}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-plum font-display text-sm font-black text-grape-soft" data-id="element-205" data-mp="2xpedbj4jalmr">
                {i + 1}
              </span>
              <div className="min-w-0" data-id="element-206" data-mp="255xzi6neyhmj">
                <p className="text-sm font-bold text-plum sm:text-base" data-id="element-207" data-mp="208xrhq7074ss">{s.title}</p>
                <p className="mt-0.5 text-sm text-plum/65" data-id="element-208" data-mp="206v1h65upbo2">{s.desc}</p>
                {s.chips.length > 0 && <div className="mt-2 flex flex-wrap gap-1.5" data-id="element-209" data-mp="1wd7hptwnqa56">
                    {s.chips.map(c => <span key={c} className={`rounded-md px-2 py-0.5 text-xs font-semibold ${c.startsWith('[') ? 'bg-lilac text-grape-deep' : 'bg-plum text-white'}`} data-id="element-210" data-mp="213ntzaoqrppy">
                        {c}
                      </span>)}
                  </div>}
              </div>
            </li>)}
        </ol>

        <div className="flex flex-col items-center justify-between gap-1 bg-plum px-5 py-3 text-center sm:flex-row sm:text-left" data-id="element-211" data-mp="1dev681i9wo6f">
          <p className="text-sm font-semibold text-white/80" data-id="element-212" data-mp="1ncrdujc050zs">No advanced prompt-engineering experience required.</p>
          <p className="text-sm font-black text-grape-soft" data-id="element-213" data-mp="2ttcvrq99ztsm">You stay in control</p>
        </div>
      </div>
    </div>;
}